import { render, staticRenderFns } from "./welcome_deergayu.vue?vue&type=template&id=14b30534&scoped=true"
import script from "./welcome_deergayu.vue?vue&type=script&lang=js"
export * from "./welcome_deergayu.vue?vue&type=script&lang=js"
import style0 from "./welcome_deergayu.vue?vue&type=style&index=0&id=14b30534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b30534",
  null
  
)

/* custom blocks */
import block0 from "./welcome_deergayu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports